import Lottie from 'react-lottie';
import animationData from '../../../assets/lotties/atripa_loading_main4.json';
import "./loading.scss";
import { CircularProgress } from '@mui/material';
export default function Loading({ text, size }) {
    //lotties
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        // <div className={`loading`}><Lottie className="lottie" options={defaultOptions} /></div>
        <div className={`loading`}><CircularProgress color="success" /></div>
    );
}
